import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { AllUndeliveredProjectPackagesView } from "src/components/views/erp/project/delivery/AllUndeliveredProjectPackagesView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/project/delivery/undeliveredPackages")({
	staticData: { title: i18n.t("undelivered_packages"), legacyViewKey: "undeliveredProjectPackagesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <AllUndeliveredProjectPackagesView />;
}
